import { useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CreateTccActionButton } from "routes/tcc/components/create-tcc-action-buttons";
import useAxios from "utils/useAxios";
import { ListingModalRef } from "../../../../components/ButtonModal";
import SubmitConfirmationModal from "./submitConfirmationModal";
import RejectConfirmationModal from "./rejectConfirmationModal";
import ApproveConfirmationModal from "./approveConfirmationModal";
import Spinner from "../../../../components/Spinner";
import {
  useCreateArtworkCollectionStore
} from "../../../artwork/context/collection/create/CreateArtworkCollectionContext";
import { submitCollectionRequest } from "../../helpers/artworkColelctionSubmitHelper";
import { Predicates } from "../../../../libraries/predicates/predicates";
import { CreateCollectionActions } from "../../state/collection/create";
import { CreateArtworkCollectionTypes } from "../../state/collection/create/data";

export const actionButtons = () => {};

type ArtworkActionButtonsGroupProps = {
  isReadOnlyRequest: boolean;
  isEditing: boolean;
  isSaveOrSubmitInProgress: boolean;
  username: string;
  hasApproverPermission: boolean;
  hasCreatorPermission: boolean;
  setIsSaveOrSubmitInProgress: (isLoading: boolean) => void;
};

const ArtworkCollectionActionButtonsGroup = ({
  isReadOnlyRequest,
  isEditing,
  isSaveOrSubmitInProgress,
  username,
  setIsSaveOrSubmitInProgress,
  hasApproverPermission,
  hasCreatorPermission,
}: ArtworkActionButtonsGroupProps) => {
  const navigate = useNavigate();
  const axios = useAxios();
  const modalRef = useRef<ListingModalRef>(null);

  const { state, dispatch } = useCreateArtworkCollectionStore();

  const [previeousState, setPreviousState] = useState<any>({});

  const { code } = useParams();

  // @ts-ignore
  const actionButtons: { [key: string]: any } = {
    save: {
      show:
        !state.isReadOnly &&
        hasCreatorPermission &&
        (state.status?.name === "CREATED" ||
           (state.status?.name !== "SUBMITTED" &&
            state.status?.name !== "APPROVED")),
      disabled: isSaveOrSubmitInProgress || !state.isValid,
      buttonStyleClass: "btn-primary",
      description: "Save",
      className: "ms-auto",
      clickHandler: () => {
        const data: any = {
          requestId: state?.id,
          action: state?.id ? "EDITED":"CREATED",
          action_user: username,
          data: JSON.stringify(state),
          reason: null,
        };
        submitCollectionRequest(
          axios,
          data,
          username,
          dispatch,
          setIsSaveOrSubmitInProgress,
          navigate,
          "/artwork/approvals",
          true,
          state.image,
        );
      },
      isButtonModal: false,
    },
    submit: {
      show:
        !hasApproverPermission &&
        ((!state.isReadOnly &&
            hasCreatorPermission &&
            state.status?.name !== "SUBMITTED") ||
          state.status?.name === "CREATED"),
      disabled: isSaveOrSubmitInProgress || !state.isValid,
      buttonStyleClass: "btn-primary",
      description: "Submit for Approval",
      className: "ms-auto",
      clickHandler: () => {},
      isButtonModal: true,
      modalTitle: "Confirm Collection Request submission",
      modal: (
        <SubmitConfirmationModal
          onConfirm={() => {
            const data: any = {
              requestId: state?.id,
              action: state?.id ? "SUBMITTED" : "CREATED",
              action_user: username,
              data: JSON.stringify(state),
              reason: null,
              comment: state.submitComment,
            };

            submitCollectionRequest(
              axios,
              data,
              username,
              dispatch,
              setIsSaveOrSubmitInProgress,
              navigate,
              "/artwork/approvals",
              true,
              state.image,
            );
            modalRef.current?.closeModal();
          }}
          parentModalRef={modalRef}
        />
      ),
      modalRef: modalRef,
    },
    approve: {
      show: (state.status?.name !== "APPROVED" && state.status?.name !== "REJECTED") && hasApproverPermission,
      disabled: isSaveOrSubmitInProgress || !state.isValid,      buttonStyleClass: "btn-primary",
      description: "Approve",
      className: "ms-auto",
      clickHandler: () => {},
      isButtonModal: true,
      modalTitle: "Approve",
      modal: (
        <ApproveConfirmationModal
          onConfirm={() => {
            const data: any = {
              requestId: state?.id,
              action: "APPROVED",
              action_user: username,
              data: JSON.stringify(state),
              reason:
                Predicates.isNotNullAndNotUndefinedAndNotEmpty(
                  state?.reject_reason,
                ) && state?.reject_reason,
              comment: state.submitComment,
            };

            submitCollectionRequest(
              axios,
              data,
              username,
              dispatch,
              setIsSaveOrSubmitInProgress,
              navigate,
              "/artwork/",
              true,
              state.image, //TODO: VERIFY WHEN UPDATE,
            );

            modalRef.current?.closeModal();
          }}
          parentModalRef={modalRef}
        />
      ),
      modalRef: modalRef,
    },
    reject: {
      show: (state.status?.name !== "APPROVED" && state.status?.name !== "REJECTED" && state.status?.name !== "CREATED" && !!state.status?.name  ) && hasApproverPermission,
      disabled: isSaveOrSubmitInProgress || !state.isValid,      buttonStyleClass: "btn-danger",
      description: "Reject",
      className: "ms-auto",
      clickHandler: () => {},
      isButtonModal: true,
      modalTitle: "Confirm Collection Request Rejection",
      modal: (
        <RejectConfirmationModal
          onConfirm={() => {
            const data: any = {
              requestId: state?.id,
              action: "REJECTED",
              action_user: username,
              data: JSON.stringify(state),
              reason: JSON.stringify(state?.reject_reason),
              comment: state.submitComment,
            };

            submitCollectionRequest(
              axios,
              data,
              username,
              dispatch,
              setIsSaveOrSubmitInProgress,
              navigate,
              "/artwork/approvals",
              true,
              state.image, //TODO: VERIFY WHEN UPDATE,
            );

            modalRef.current?.closeModal();
          }}
          parentModalRef={modalRef}
        />
      ),
      modalRef: modalRef,
    },

    edit: {
      show:
        state.status?.name === "APPROVED" &&
        hasApproverPermission &&
        state.isReadOnly,
      disabled: isSaveOrSubmitInProgress,
      buttonStyleClass: "btn-primary",
      description: "Edit",
      className: "ms-auto",
        clickHandler: () => {
          setPreviousState({ ...state });
          dispatch(CreateCollectionActions.setStateValue(
        CreateArtworkCollectionTypes.SET_IS_READ_ONLY, false));
        },
        modalTitle: "Approve",
        isButtonModal: false,
      },
      cancel: {
        show:
          state.status?.name === "APPROVED" &&
          hasApproverPermission &&
          !state.isReadOnly,
        disabled: isSaveOrSubmitInProgress,
        buttonStyleClass: "btn-secondary",
        description: "Cancel",
        className: "ms-auto",
        clickHandler: () => {
          dispatch(CreateCollectionActions.setStateValue(CreateArtworkCollectionTypes.SET_IS_READ_ONLY, true));
          if(!!previeousState.id){
            dispatch(
              CreateCollectionActions.setStateValue(CreateArtworkCollectionTypes.SET_ARTWORK_COLLECTION,{ ...previeousState }),
            );
          }
        },
        modalTitle: "Approve",
        isButtonModal: false,
      },
      approveEdit: {
        show:
          !isReadOnlyRequest &&
            state?.status?.name === "APPROVED" &&
            hasApproverPermission,
        disabled: isSaveOrSubmitInProgress || !state.isValid,
        buttonStyleClass: "btn-primary",
        description: "Approve edit",
        className: "ms-auto",
        clickHandler: () => {},
        isButtonModal: true,
        modalTitle: "Approve edit",
        modal: (
          <ApproveConfirmationModal
            onConfirm={() => {
              const data: any = {
                requestId: state.id,
                action: "EDITED",
                action_user: username,
                context: 2,
                country: 21,
                data: JSON.stringify(state),
                reason: null,
                comment: state.submitComment,
              };

              submitCollectionRequest(
                axios,
                data,
                username,
                dispatch,
                setIsSaveOrSubmitInProgress,
                navigate,
                "/artwork",
                true,
                state.image
              );

              modalRef.current?.closeModal();
            }}
            parentModalRef={modalRef}
          />
        ),
        modalRef: modalRef,
    },
    delete: {
      show: false, //for now is impossible to delete artworks, verify if this feature should be turned on and test if the request is working
      // show: !!code &&
      //   ((!isReadOnlyRequest &&
      //       state.requestStatus === "APPROVED" && isEditing &&
      //       hasApproverPermission) ||
      //     (!isReadOnlyRequest && hasApproverPermission)),
      disabled: isSaveOrSubmitInProgress || !state.isValid,
      buttonStyleClass: "btn-danger",
      description: "Delete",
      className: "ms-auto",
      clickHandler: () => {},
      isButtonModal: true,
      modalTitle: "Confirm Delete",
      modal: (
        <ApproveConfirmationModal
          onConfirm={() => {
            const data: any = {
              requestId: state.id,
              action: "DELETED",
              action_user: username,
              context: 2,
              country: 21,
              data: JSON.stringify(state),
              reason: null,
              comment: state.submitComment,
            };

            submitCollectionRequest(
              axios,
              data,
              username,
              dispatch,
              setIsSaveOrSubmitInProgress,
              navigate,
                       "/artwork",
              true,
            );

            modalRef.current?.closeModal();
          }}
          parentModalRef={modalRef}
        />
      ),
      modalRef: modalRef,
    },
  };

  return (
    <div className="d-flex justify-content-end mt-auto pt-3">
      <div className="d-flex gap-3 me-auto">
        <CreateTccActionButton {...actionButtons.save} />
        <CreateTccActionButton {...actionButtons.reject} />
        <CreateTccActionButton {...actionButtons.delete} />
      </div>

      <div className="d-flex gap-3" style={{ height: 38 }}>
        {isSaveOrSubmitInProgress && (
          <Spinner hideLabel={true} mediumSpinner={true} />
        )}

        <CreateTccActionButton {...actionButtons.submit} />

        <CreateTccActionButton {...actionButtons.approve} />

        <CreateTccActionButton {...actionButtons.continueReview} />

        <CreateTccActionButton {...actionButtons.reOpen} />
        <CreateTccActionButton {...actionButtons.approveEdit} />

        <CreateTccActionButton {...actionButtons.edit} />

        <CreateTccActionButton {...actionButtons.cancel} />
      </div>
    </div>
  );
};

export default ArtworkCollectionActionButtonsGroup;
